/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzsothers9Inputs */

const en__field_enum_mzsothers9 = /** @type {(inputs: _Field_Enum_Mzsothers9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`others`)
};

const de__field_enum_mzsothers9 = /** @type {(inputs: _Field_Enum_Mzsothers9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiges`)
};

/**
* | output |
* | --- |
* | "others" |
*
* @param {_Field_Enum_Mzsothers9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzsothers9 = /** @type {((inputs?: _Field_Enum_Mzsothers9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzsothers9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzsothers9(inputs)
	return de__field_enum_mzsothers9(inputs)
});
export { _field_enum_mzsothers9 as "_field_enum_MZSOTHERS" }